<template>
  <div>
    <headline :content="$t('project.personnel')">
      <div class="d-block w-100">
        <div class="justify-end mb-2 d-flex">
          <v-checkbox v-model="isShowPermissionDetail" :label="$t('project.show_permission_detail')" />
        </div>
      </div>
    </headline>
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <v-card v-if="admins[0] && !isLoading" class="mb-6">
          <v-card-title class="d-flex justify-space-between">
            <div>
              <h1>{{ $t('project.project_name', { name: admins[0].project.name }) }}</h1>
            </div>
            <div>
              <v-btn color="info" @click="addAdmin()">
                <v-icon class="me-2">mdi-account-plus</v-icon>{{ $t('project.add_admin') }}
              </v-btn>
            </div>
          </v-card-title>
          <v-card-text>
            <h3 class="pb-2">{{ $t('project.project_admin') }}</h3>
            <v-row>
              <v-col cols="3" v-for="(projectAdmin, index) in projectAdmins" :key="index">
                <div v-if="projectAdmin.user">
                  <v-card height="100%">
                    <v-card-title>
                      <v-icon class="me-2">mdi-account</v-icon>
                        {{ projectAdmin.user.firstName ? projectAdmin.user.firstName : '-'}}
                        {{ projectAdmin.user.lastName ? projectAdmin.user.lastname : '-'}}
                    </v-card-title>
                    <v-card-text v-if="projectAdmin.user.tel">
                      <b>{{ $t('market.company_tel') }} :</b>
                      {{ projectAdmin.user.tel }}
                    </v-card-text>
                    <v-card-actions class="justify-end d-flex">
                      <v-btn color="error" @click="confirmRemoveAdmin(projectAdmin)"
                        v-if="admins[0].objectId != projectAdmin.objectId" outlined>{{ $t('action_type.delete') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-col>
            </v-row>
            <hr class="my-5" />
            <v-row>
              <v-col cols="12" class="d-flex justify-space-between">
                <div></div>
                <v-btn color="info" @click="addEmployee()">
                  <v-icon class="me-2">mdi-account-plus</v-icon>{{ $t('project.add_employee') }}
                </v-btn>
              </v-col>
              <v-col cols="12" v-for="(market, index) in markets" :key="index">
                <v-card color="#f5fff5">
                  <v-card-text class="pb-0 d-flex justify-space-between">
                    <div>
                      <h3>
                        <v-icon left>mdi-store</v-icon>
                        {{ market.name }}
                      </h3>
                    </div>
                    <div>
                      <!-- <v-btn color="info" @click="addEmployee(market.objectId)">
                        <v-icon class="me-2">mdi-account-plus</v-icon>เพิ่มพนักงาน
                      </v-btn> -->
                    </div>
                  </v-card-text>
                  <v-card-text class="black--text">
                    <v-row v-if="hashMarketEmployee[market.objectId] &&
                      hashMarketEmployee[market.objectId].length
                      ">
                      <v-col cols="4" v-for="(employee, index) in hashMarketEmployee[
                        market.objectId
                      ]" :key="index">
                        <v-card height="100%">
                          <v-card-title>
                            <v-icon class="me-2">mdi-account</v-icon>
                            {{ employee.user.firstName }}
                            {{ employee.user.lastName }}
                          </v-card-title>
                          <v-card-text v-if="employee.user.tel">
                            <b>{{ $t('market.company_tel') }} :</b>
                            {{ employee.user.tel }}
                            <div class="group" v-if="isShowPermissionDetail">
                              <div class="group-box" v-for="(label, idx) in formDataLabel" :key="`group-box-${idx}`">
                                <div class="group-header"> {{ label.text }} </div>
                                <div class="group-data" v-for="(inLabel, index) in  label.value"
                                  :key="`group-data-${index}`">
                                  <v-checkbox v-if="!inLabel.isGroupping" readonly v-model="employee[inLabel.value]"
                                    :label="inLabel.text" off-icon="mdi-close-circle-outline"
                                    on-icon="mdi-check-circle-outline" hide-details />
                                  <div class="group-items" v-else>
                                    <v-checkbox class="group-item" readonly v-model="employee[inLabel.value]"
                                      :label="inLabel.text" off-icon="mdi-close-circle-outline"
                                      on-icon="mdi-check-circle-outline" hide-details />
                                    <div class="group-item" v-if="employee[inLabel.value]">
                                      <v-checkbox v-if="!inLabel.inGroup" v-for="(inGroup, gIdx) in inLabel.groups"
                                        :key="`group-item-${gIdx}`" readonly v-model="employee[inGroup.value]"
                                        :label="inGroup.text" off-icon="mdi-close-circle-outline"
                                        on-icon="mdi-check-circle-outline" hide-details />
                                      <div class="in-group-item" v-else>
                                        <div class="in-group-item-header">- {{ inGroup.text }}</div>
                                        <v-checkbox
                                          v-if="employee.enableAppealObject && employee.enableAppealObject[inGroup.value]"
                                          v-for="(inGroup2, g2Idx) in inLabel.inGroup" :key="`in-group-item-${g2Idx}`"
                                          readonly v-model="employee.enableAppealObject[inGroup.value][inGroup2.value]"
                                          :label="inGroup2.text" off-icon="mdi-close-circle-outline"
                                          on-icon="mdi-check-circle-outline" hide-details />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-card-text>
                          <v-card-actions class="justify-end d-flex">
                            <v-btn color="warning" @click="editPermissionDailog(employee)" outlined>{{ $t('project.set_permission') }}</v-btn>
                            <v-btn color="error" @click="confirmRemoveEmployee(employee)" outlined>{{ $t('action_type.delete') }}</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                    <div v-else class="text-center">
                      <p>{{ $t('project.no_employee') }}</p>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </layout>
    <v-dialog v-model="isAddDialog" max-width="600" @click:outside="onCloseDialog">
      <v-card>
        <v-card-title>
          {{
            tempType == "admin" ? $t('project.add_admin') : $t('project.add_employee')
          }}
        </v-card-title>
        <v-card-text>
          <v-row class="mb-3 align-center">
            <v-col cols="9">
              <PhoneNumber
                v-if="isAddDialog"
                ref="inputPhoneNumber"
                :tel.sync="formData.tel"
                :interTel.sync="formData.interTel"
                :phoneCode.sync="formData.phoneCode"
                flat
                background-color="grey lighten-4"
                solo
                :phoneLabel="$t('account.phone_number')"
                required
                type="text"
                :isLabel="false"
              />
            </v-col>
            <v-col cols="3">
              <v-btn color="primary" class="mb-3" :disabled="!formData.tel" large block @click="searchUser()">
                <v-icon class="me-2">mdi-magnify</v-icon>{{ $t('search') }}
              </v-btn>
            </v-col>
          </v-row>
          <div v-if="!isLoadingUser">
            <div v-if="!invalidUser">
              <v-card v-for="(user, index) in userFromTel" :key="index">
                <v-card-title class="d-flex justify-space-between">
                  <div>{{ user.firstName }} {{ user.lastName }}</div>
                  <div>
                    <v-btn color="primary" block @click="addPermission(user)" :disabled="isLoading">
                      <v-icon class="me-2">mdi-plus</v-icon>
                      {{ tempType == "admin" ? $t('project.add_admin') : $t('project.add_employee') }}
                    </v-btn>
                  </div>
                </v-card-title>
                <v-card-text>
                  <span v-if="user.tel">
                    <b>{{ $t('market.company_tel') }} :</b>
                    {{ user.tel }}
                  </span>
                  <br />
                  <span v-if="user.email">
                    <b>Email :</b>
                    {{ user.email }}
                  </span>
                </v-card-text>
              </v-card>
            </div>
            <div v-else class="justify-center d-flex">{{ $t('account.no_user_found') }}</div>
          </div>
          <div v-else class="justify-center my-10 d-flex">
            <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <ConfirmDialog v-model="isConfirmDialogRemove" type="error" :title="$t('validate.want_delete_document_template', { title: $t(tempType === 'admin' ? 'project.admin_name' : 'project.employee_name') })" :text="`${tempType == 'admin' ? $t('project.admin_name') : $t('project.employee_name')} ${tempObjRemove
    ? (tempObjRemove.user.firstName || '') +
    ' ' +
    (tempObjRemove.user.lastName || '')
    : ''
    }`" @onOk="removeAdmin()" />
    <SelectPermissionDailog v-model="isSelectPermissionDailog" :employee="tempEmployee"
      @onSuccess="onSuccessSelectPermission" />
    <SelectMarketDialog v-model="isSelectMarketAdd" :title="$t('market.select_market_to_add')" :markets="tempMarkets"
      @onSuccess="createEmployees" />
    <SelectMarketDialog v-model="isSelectMarketUpdate" :title="$t('market.select_market_to_update')" :markets="tempMarkets"
      @onSuccess="updateEmployees" />
    <SelectMarketDialog v-model="isSelectMarketRemove" :title="$t('market.select_market_to_remove')" :markets="tempMarkets"
      @onSuccess="removeEmployees" btnType="error" />
  </div>
</template>

<script>
import Layout from "../../components/Layout";
import Headline from "../../components/Headline";
import { mapState } from "vuex";
import { Admin, Employee, User } from "../../classes";
import ConfirmDialog from "../../components/ConfirmDialog.component.vue";
import SelectPermissionDailog from "../../components/SelectPermissionDailog.component.vue";
import AppealLabels from "../../json/appeal-data.json";
import SelectMarketDialog from "../../components/SelectMarketDialog.vue";
import PhoneNumber from "@/components/PhoneNumber.vue";
export default {
  data() {
    return {
      AppealLabels,
      hashProject: {},
      isLoading: false,
      projectId: this.$route.params.projectId,
      project: null,
      projectAdmins: [],
      markets: [],
      employees: null,
      hashMarketEmployee: [],
      isAddDialog: false,
      tempType: "",
      formData: {
        tel: "",
        interTel: "",
        phoneCode: ""
      },
      isLoadingUser: false,
      userFromTel: [],
      invalidUser: false,
      tepmMarketId: null,
      isError: false,
      isLoadingAdd: false,
      isSuccess: false,
      isConfirmDialogRemove: false,
      tempObjRemove: null,
      isSelectPermissionDailog: false,
      tempEmployee: null,
      tempUserId: null,
      tempMarkets: null,
      isShowPermissionDetail: false,
      isSelectMarketAdd: false,
      isSelectMarketUpdate: false,
      isSelectMarketRemove: false,
      postData: null
    };
  },
  computed: {
    ...mapState({
      sessionAdmins: state => state.admin.sessionAdmins
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    formDataLabel() {
      let res = {
        tab: {
          text: this.$t('project.menu_bar'),
          value: {
            enableViewAreas: { value: 'enableViewAreas', text: this.$t('project.data_stall') },
            enableViewCustomers: { value: 'enableViewCustomers', text: this.$t('customer.customer_information') },
            enableViewAreaInterests: { value: 'enableViewAreaInterests', text: this.$t('area.area_interest') },
            enableViewBilling: { value: 'enableViewBilling', text: this.$t('market.collect_rental') },
            enableViewAccounting: { value: 'enableViewAccounting', text: this.$t('market.accounting_document') },
            enableViewReports: { value: 'enableViewReports', text: this.$t('market.summary_report') },
            enableViewIncomeExpense: { value: 'enableViewIncomeExpense', text: this.$t('market.income_expense') },
            enableViewOverall: { value: 'enableViewOverall', text: this.$t('project.analyze') },
          }
        },
        other: {
          text: this.$t('other'),
          value: {
            enableCannotCheckOut: { value: 'enableCannotCheckOut', text: this.$t('project.cannot_checkout_without_approval') },
            enableEditInvoiceAndReceipt: { value: 'enableEditInvoiceAndReceipt', text: this.$t('project.can_edit_invoice_and_receipt') },
            enableAddAccountingProduct: { value: 'enableAddAccountingProduct', text: this.$t('project.can_add_billing_list') },
            enableAddProduct: { value: 'enableAddProduct', text: this.$t('project.can_add_product') },
            enableEditTaxId: { value: 'enableEditTaxId', text: this.$t('project.can_edit_tax_id') },
            enableViewBoard: { value: 'enableViewBoard', text: this.$t('project.news_board', { name: '' }) },
            enableDigitalMeterOnOff: { value: 'enableDigitalMeterOnOff', text: this.$t('project.can_digital_meter_on_off') },
            enableDigitalMeterReset: { value: 'enableDigitalMeterReset', text: this.$t('project.can_digital_meter_reset') },
          }
        },
        project: {
          text: this.$t('project.project_level'),
          value: {
            enableViewAccountingProject: { value: 'enableViewAccountingProject', text: this.$t('project.accounting_document_level') },
            enableViewReportsProject: { value: 'enableViewReportsProject', text: this.$t('project.summary_report_level') },
          }
        },
        setting: {
          text: this.$t('setting.title'),
          value: {
            enableViewSettings: {
              value: 'enableViewSettings',
              text: this.$t('setup'),
              isGroupping: true,
              groups: {
                enableEditBillingSetting: { value: 'enableEditBillingSetting', text: this.$t('product.can_edit_invoice') },
                enableEditAreaAccountingProduct: { value: 'enableEditAreaAccountingProduct', text: this.$t('product.can_edit_billing_list') },
                enableSendApproveBillingSetting: { value: 'enableSendApproveBillingSetting', text: this.$t('task.can_send_approve_setting') },
              }
            },
          }
        },
        approve: {
          text: this.$t('product.approving'),
          value: {
            enableViewApprove: {
              value: 'enableViewApprove',
              text: this.$t('task.approve_list'),
              isGroupping: true,
              groups: {
                enableApproveAreaInterest: { value: 'enableApproveAreaInterest', text: this.$t('area.booking_area') },
                enableApproveSettingBilling: { value: 'enableApproveSettingBilling', text: this.$t('setting.invoice_setting') },
                enableApproveSettingAreaAccounting: { value: 'enableApproveSettingAreaAccounting', text: this.$t('setting.area_accounting_product_setting') },
                enableApproveCheckout: { value: 'enableApproveCheckout', text: this.$t('customer.seller_checkout') },
              }
            },
          }
        },
        appeal: {
          text: this.$t('appeal_data.notify'),
          value: {
            enableViewAppeal: {
              value: 'enableViewAppeal',
              text: this.$t('appeal.notify_appeal'),
              isGroupping: true,
              inGroup: {
                enableSend: { value: 'enableSend', text: this.$t('appeal.can_send_appeal') },
                enableEdit: { value: 'enableEdit', text: this.$t('task.can_approve_cancel_edit_appeal') },
              },
              groups: {

              }
            },
          }
        }
      }
      res.appeal.value.enableViewAppeal.groups = {}
      for (const key in this.AppealLabels.subCategory)
        res.appeal.value.enableViewAppeal.groups[key] = { value: key, text: this.$t(`appeal_data.subCategory.${this.AppealLabels.subCategory[key].value}`) }
      return res
    }
  },
  components: {
    Layout,
    Headline,
    ConfirmDialog,
    SelectPermissionDailog,
    SelectMarketDialog,
    PhoneNumber
  },
  async created() {
    this.isLoading = true;
    try {
      await this.initAdmin();
      await this.initEmployee();
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
    }
  },
  methods: {
    async initAdmin() {
      this.markets = [];
      this.projectAdmins = await Admin.getAdminByProject(this.projectId);
      for (let admin of this.sessionAdmins) {
        if (this.projectId === admin.project.objectId) {
          this.markets.push(admin.market);
        }
      }
    },
    async initEmployee() {
      this.hashMarketEmployee = {};
      this.employees = await Employee.getEmployeeByProject(this.projectId);
      for (let employee of this.employees) {
        if (!this.hashMarketEmployee[employee.market.objectId])
          this.hashMarketEmployee[employee.market.objectId] = [];
        this.hashMarketEmployee[employee.market.objectId].push(employee);
      }
    },
    addAdmin() {
      this.tempEmployee = null;
      this.tempType = "admin";
      this.formData.tel = "";
      this.isAddDialog = true;
      this.invalidUser = false;
      this.userFromTel = [];
    },
    addEmployee(marketId) {
      this.tempEmployee = null;
      this.tempType = "employee";
      this.formData.tel = "";
      this.isAddDialog = true;
      this.invalidUser = false;
      this.tepmMarketId = marketId;
      this.userFromTel = [];
    },
    onCloseDialog() {
      this.formData = {
        tel: "",
        interTel: "",
        phoneCode: ""
      };
      this.isAddDialog = false;
    },
    async searchUser() {
      this.isLoadingUser = true;
      this.invalidUser = false;
      this.userFromTel = [];
      try {
        if (this.formData.tel) {
          this.userFromTel = await User.getUserByTel(this.formData.tel);
          if (!this.userFromTel || (this.userFromTel && !this.userFromTel.length))
          this.invalidUser = true;
        }
        this.isLoadingUser = false; 
      } catch (error) {
        console.log(error)
        this.isLoadingUser = false;
      }
    },
    async addPermission(user) {
      this.isLoading = true;
      try {
        if (this.tempType == "employee") {
          this.tempUserId = user.objectId;
          if (this.projectAdmins.find(d => d.user.objectId == user.objectId)) {
            this.$toast.show({
              content: this.$t('project.user_is_project_admin'),
              color: "error"
            });
            this.isAddDialog = false;
          } else {
            this.isSelectPermissionDailog = true;
          }
        } else {
          await Admin.createAdmin(user.objectId, this.projectId);
          await this.initAdmin();
          this.isSuccess = true;
          this.isAddDialog = false;
        }
        this.isLoading = false;
      } catch (error) {
        // this.isError = true;
        this.isLoading = false;
        this.isAddDialog = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    editPermissionDailog(employee) {
      this.tempEmployee = employee;
      this.tempUserId = employee.user.objectId;
      this.isSelectPermissionDailog = true;
    },
    async onSuccessSelectPermission(formData) {
      this.postData = formData
      this.tempMarkets = []
      if (formData.id) {
        for (let market of this.markets) {
          if (this.employees.find(d => d.market.objectId == market.objectId && d.user.objectId == this.tempUserId)) {
            this.tempMarkets.push(market)
          }
        }
        this.isSelectMarketUpdate = true
      } else {
        for (let market of this.markets) {
          if (!this.employees.find(d => d.market.objectId == market.objectId && d.user.objectId == this.tempUserId)) {
            this.tempMarkets.push(market)
          }
        }
        this.isSelectMarketAdd = true
      }
    },
    async createEmployees(marketIds) {
      this.isAddDialog = false;
      this.isLoading = true;
      try {
        for (let marketId of marketIds) {
          this.postData.marketId = marketId;
          this.postData.userId = this.tempUserId;
          await Employee.createEmployee(this.postData);
        }
        await this.initEmployee();
        this.isSuccess = true;
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    async updateEmployees(marketIds) {
      this.isAddDialog = false;
      this.isLoading = true;
      try {
        for (let marketId of marketIds) {
          this.postData.id = this.employees.find(d => d.market.objectId == marketId && d.user.objectId == this.tempUserId).objectId
          await Employee.updateEmployee(this.postData);
        }
        await this.initEmployee();
        this.isSuccess = true;
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    async confirmRemoveAdmin(obj, type) {
      this.tempType = type;
      this.tempObjRemove = obj;
      this.isConfirmDialogRemove = true;
    },
    async removeAdmin() {
      this.isLoading = true;
      try {
        await Admin.removeAdmin(this.tempObjRemove.objectId);
        await this.initAdmin();
        this.isSuccess = true;
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    async confirmRemoveEmployee(employee) {
      this.tempEmployee = employee
      this.tempUserId = employee.user.objectId;
      this.tempMarkets = []
      for (let market of this.markets) {
        if (this.employees.find(d => d.market.objectId == market.objectId && d.user.objectId == this.tempUserId)) {
          this.tempMarkets.push(market)
        }
      }
      this.isSelectMarketRemove = true;
    },
    async removeEmployees(marketIds) {
      this.isAddDialog = false;
      this.isLoading = true;
      try {
        for (let marketId of marketIds) {
          let employeeId = this.employees.find(d => d.market.objectId == marketId && d.user.objectId == this.tempUserId).objectId
          await Employee.removeEmployee(employeeId);
        }
        await this.initEmployee();
        this.isSuccess = true;
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.text-black {
  color: rgba(0, 0, 0, 0.6);
}

div .v-icon {
  margin-right: 5px;
}


.group {
  // padding: 10px 0;

  .group-box {
    position: relative;
    border: 1px dashed rgb(219, 219, 219);
    border-radius: 5px;
    padding: 10px;
    margin: 25px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    .group-header {
      position: absolute;
      top: -12px;
      left: 10px;
      font-size: 15px;
      // margin-top: -20px;
      background: #fff;
      width: fit-content;
      padding: 0 10px;
      color: rgb(182, 182, 182);
    }

    .group-data {
      display: flex;
      flex-wrap: wrap;

      .v-input {
        margin-top: 5px;
      }

      .group-items {
        display: flex;
        flex-wrap: wrap;

        // width: 100%;
        .group-item {
          // margin-top: 15px;
          margin-left: 10px;
          min-width: 120px;

          .in-group-item {

            .in-group-item-header {
              font-size: 15px;
              margin-top: 15px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>